import React from "react";
import { Link } from "react-router-dom";
import Divider from "../Others/Divider";

export default function SiteFooter() {
  return (
    <footer className="footer mt-36">
      <div className="mx-auto max-w-5xl px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center text-white px-8">
          <img
            className="transform scale-150 h-16 w-auto"
            src="/logo-nobgm.png"
            alt="/"
          />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-6 md:gap-8 lg:gap-12">
          <li>
            <Link to={'/'} className="text-white transition hover:text-white/75" href="/">
              Home
            </Link>
          </li>
          <li>
            <Link to={'/Shop'} className="text-white transition hover:text-white/75" href="/">
              Shop
            </Link>
          </li>
          <li>
            <Link to={'/about'} className="text-white transition hover:text-white/75">
              About
            </Link>
          </li>
        </ul>

        <ul className="mt-12 flex justify-center gap-6 md:gap-8">
          
          <li>
            <a href="https://www.tiktok.com/@attiva.eg" className="text-white transition hover:text-white/75">
              <span className="sr-only">Tiktok</span>
              <svg className="h-6 w-5" fill="white" xmlns="http://www.w3.org/2000/svg" height="0.5em" viewBox="0 0 448 512">
                <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
              </svg>
            </a>
          </li>

          <li>
            <a href="https://www.instagram.com/attiva.eg" className="text-white transition hover:text-white/75">
              <span className="sr-only">Instagram</span>
              <svg className="h-6 w-5" fill="white" xmlns="http://www.w3.org/2000/svg" height="0.5em" viewBox="0 0 448 512">
                <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
              </svg>
            </a>
          </li>

        </ul>
      </div>
    </footer>
  );
}
